module.exports = __webpack_public_path__ + "static/media/covid_icon.497e4710.svg";